<template>
  <div class="review-cell columns">
    <div class="column is-12-mobile is-12-tablet is-9-desktop">
      <span>{{ label }}</span>
      <span><strong>{{ value }}</strong></span>
      <slot name="dependencies"></slot>
    </div>
    <div class="column is-12-mobile is-12-tablet is-3-desktop">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'review-cell-component',
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
        default: ''
      }
    }
  }
</script>
<style lang="sass" scoped>
  .review-cell
    margin: 0
    margin-bottom: 1.462rem !important
    .column
      padding: 0 !important
    & div > span:first-child
      display: block
      margin-bottom: 0.2em
      color: #4A4A4A
</style>
